var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Profile "),_c('br'),_c('v-btn',{on:{"click":_vm.testBackendAuth}},[_vm._v(" click ")]),_c('pre',[_vm._v(_vm._s(_vm.user))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }